import useCompareStore from '../store/compareStore';
import useGlobalStore from '../store/globalStore'
import {ref} from 'vue';
export function useRestHomeCompare() {
  const compareStore = useCompareStore()
  const globalStore = useGlobalStore()
  const sendDataLayer = ref(false)
  const addRemoveToCompareList = (id, name, e)  => {
    const ele = e.target;
    const careHomeCompareList = compareStore.careHomeCompareList;

    if (ele.checked) {
      addToCompareItem(id, ele, name)
    } else {
      // remove item from the list
      const key = careHomeCompareList.findIndex(item => item.id === id)
      careHomeCompareList.splice(key, 1)

      if (careHomeCompareList.length === 0) {
        compareStore.setShowCareHomeCompareList(false)
      }

      compareStore.setCareHomeCompareList(careHomeCompareList)
      localStorage.setItem('careHomeCompareList', JSON.stringify(careHomeCompareList))
    }
  }

  const addToCompareItem = (id, ele, name) => {
    const careHomeCompareList = compareStore.careHomeCompareList;
    const key = careHomeCompareList.findIndex(item => item.id === id);

    if (key === -1) {
      // add item to the list
      careHomeCompareList.push(
        {id : id, name: name, operatorId: ele.dataset.operatorId, operatorName: ele.dataset.operatorName}
      );
    }

    compareStore.setShowCareHomeCompareList(true)

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'add to compare',
      'villageName': ele.dataset.careHomeName,
      'villageId': id,
      'villageType': 'care home',
      'villageOperator': ele.dataset.operatorName,
      'villageOperatorId': ele.dataset.operatorId,
      'subscription': ele.dataset.subscription,
      'region': ele.dataset.region,
      'district': ele.dataset.district,
    });

    compareStore.setCareHomeCompareList(careHomeCompareList)
    localStorage.setItem('careHomeCompareList', JSON.stringify(careHomeCompareList))
  }

  const isCompareChecked = (id) => {
    const key = compareStore.careHomeCompareList.findIndex(item => item.id === id);
    return (key !== -1);
  }

  const printCompare = (e)  => {
    if (!sendDataLayer.value) {
      e.preventDefault();
      const careHomeCompareList = compareStore.careHomeCompareList;
      window.dataLayer = window.dataLayer || [];

      careHomeCompareList.forEach((item) => {
        window.dataLayer.push({
          'event': 'print compare list',
          'villageName': item.name,
          'villageId': item.id,
          'villageType': 'care home',
          'villageOperator': item.operatorName,
          'villageOperatorId': item.operatorId,
          'subscription': item.subscription,
          'region': item.region,
          'district': item.district,
        });
      });
      sendDataLayer.value = true;
      e.target.click();
    } else {
      e.target.click();
    }
  }

  const showCareHomeForm = (careHomeId, careHomeName, action, operatorName, OperatorId, e) => {
    localStorage.setItem('preSiteTitle', document.title);

    if (e.target.dataset.metaTitle) {
      document.title = e.target.dataset.metaTitle;
    }

    let title = ''
    let customField = ''

    if (action === 'availability') {
      title = careHomeName
      customField = 'Room availability enquiry'
    }

    if(action === 'email-care-home') {
      globalStore.setModal(
        {
          id: careHomeId,
          propertyName: careHomeName,
          operatorId: OperatorId,
          operatorName: operatorName,
          enquiryTypeFull: e.target.dataset.enquiryTypeFull,
          subscription: e.target.dataset.subscription,
          enquiryRegion: e.target.dataset.enquiryRegion,
          enquiryDistrict: e.target.dataset.enquiryDistrict,
          name: 'careHomeEmailFormModal',
          title: `Email care home <br><span>${careHomeName}</span>`,
          customField: 'Ask question',
          descriptionPlaceholder: `Please send me more information about rooms at ${careHomeName} and whether you have current or upcoming availability`
        }
      )
    } else {
      globalStore.setModal(
        {
          name: 'careHomeFormModal',
          id: careHomeId,
          title: title,
          propertyName: careHomeName,
          operatorName: operatorName,
          operatorId: OperatorId,
          enquiryTypeFull: e.target.dataset.enquiryTypeFull,
          subscription: e.target.dataset.subscription,
          enquiryRegion: e.target.dataset.enquiryRegion,
          enquiryDistrict: e.target.dataset.enquiryDistrict,
          typesOfHomes: e.target.dataset.typesOfHomes,
          descriptionPlaceholder: '',
          customField: customField,
        }
      )
    }
  }

  const removeSelectedCompareItem = (id) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const compareList = urlParams.get('compareList')
    const compareListArr = compareList.split(',');
    const index = compareListArr.indexOf(`${id}`);

    if (index > -1) {
      compareListArr.splice(index, 1);
      compareStore.careHomeCompareList.splice(index, 1);
      localStorage.setItem('careHomeCompareList', JSON.stringify(compareStore.careHomeCompareList));
    }

    if (compareListArr.length === 0) {
      window.location.href = `/rest-homes`;
    } else {
      window.location.href = `/rest-homes-compare?compareList=${compareListArr.join(',')}`;
    }
  }

  return {
    addRemoveToCompareList,
    addToCompareItem,
    isCompareChecked,
    printCompare,
    showCareHomeForm,
    removeSelectedCompareItem,
  }
}
